<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.bankNo"
                          :label="labels.bankNo"
                          :error-messages="errors.collect('bankNo')"
                          data-vv-name="bankNo"
                          :data-vv-as="labels.bankNo"
                          data-vv-scope="filters"
                          v-validate="'max:2'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.bankAbbrev"
                          :label="labels.bankAbbrev"
                          :error-messages="errors.collect('bankAbbrev')"
                          data-vv-name="bankAbbrev"
                          :data-vv-as="labels.bankAbbrev"
                          data-vv-scope="filters"
                          v-validate="'max:8'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.bankAcctName"
                          :label="labels.bankAcctName"
                          :error-messages="errors.collect('bankAcctName')"
                          data-vv-name="bankAcctName"
                          :data-vv-as="labels.bankAcctName"
                          data-vv-scope="filters"
                          v-validate="'max:120'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.fullBankNo"
                          :label="labels.fullBankNo"
                          :error-messages="errors.collect('fullBankNo')"
                          data-vv-name="fullBankNo"
                          :data-vv-as="labels.fullBankNo"
                          data-vv-scope="filters"
                          v-validate="'max:20'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.branch"
                          :label="labels.branch"
                          :error-messages="errors.collect('branch')"
                          data-vv-name="branch"
                          :data-vv-as="labels.branch"
                          data-vv-scope="filters"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field
                          v-model="filters.glacctNo"
                          :label="labels.glacctNo"
                          :error-messages="errors.collect('glacctNo')"
                          data-vv-name="glacctNo"
                          :data-vv-as="labels.glacctNo"
                          data-vv-scope="filters"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <template v-if="showMore">
                      <v-layout row>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field
                            v-model="filters.fund"
                            :label="labels.fund"
                            :error-messages="errors.collect('fund')"
                            data-vv-name="fund"
                            :data-vv-as="labels.fund"
                            data-vv-scope="filters"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field
                            v-model="filters.acctNoSfx"
                            :label="labels.acctNoSfx"
                            :error-messages="errors.collect('acctNoSfx')"
                            data-vv-name="acctNoSfx"
                            :data-vv-as="labels.acctNoSfx"
                            data-vv-scope="filters"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field
                            v-model="filters.curr"
                            :label="labels.curr"
                            :error-messages="errors.collect('curr')"
                            data-vv-name="curr"
                            :data-vv-as="labels.curr"
                            data-vv-scope="filters"
                            v-validate="'max:4'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            v-model="filters.bankAcctBal"
                            :label="labels.bankAcctBal"
                            :error-messages="errors.collect('bankAcctBal')"
                            data-vv-name="bankAcctBal"
                            :data-vv-as="labels.bankAcctBal"
                            data-vv-scope="filters"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click.native="showMore = true" v-if="!showMore">Show More Filters</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="$router.push({ name: 'bankAcctDet', params: { bankNo: 'new', bankAcctMode: 'New' } })">
          New Bank Account
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-flex xs12 class="mt-1">
        <message :messages="messages"></message>
      </v-flex>
      <v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            v-bind:options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.bankNo }}</td>
                <td class="text-xs-left">{{ row.item.bankAbbrev }}</td>
                <td class="text-xs-left">{{ row.item.bankAcctName }}</td>
                <td class="text-xs-left">{{ row.item.fullBankNo }}</td>
                <td class="text-xs-left">{{ row.item.branch }}</td>
                <td class="text-xs-left">{{ row.item.glacctNo }}</td>
                <td class="text-xs-left">{{ row.item.fund }}</td>
                <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                <td class="text-xs-left">{{ row.item.curr }}</td>
                <td class="text-right">{{ row.item.bankAcctBal | formatDisplayNumber }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="$router.push({ name: 'bankAcctDet', params: { bankNo: row.item.bankNo, bankAcctMode: 'Review' } })"
                    query
                    @query="$router.push({ name: 'bankAcctDet', params: { bankNo: row.item.bankNo, bankAcctMode: 'Query' } })"
                    remove
                    @remove="doDelete(row.item.bankNo)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
        <confirm ref="confirmDelete">
          <p>Are you sure you want to delete the selected Bank Account? ({{ selectedBankNo }})</p>
        </confirm>
      </v-flex>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number.js'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Bank No.', value: 'bankNo' },
        { text: 'Bank', value: 'bankAbbrev' },
        { text: 'Account Name', value: 'bankAcctName' },
        { text: 'Full Bank No.', value: 'fullBankNo' },
        { text: 'Branch', value: 'branch' },
        { text: 'GL Account No.', value: 'glacctNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Currency', value: 'curr' },
        { text: 'Balance', value: 'bankAcctBal', align: 'right' },
        TableConst.tableActionHeader
      ],
      labels: {
        bankNo: 'Bank No.',
        bankAbbrev: 'Bank',
        bankAcctName: 'Account Name',
        fullBankNo: 'Full Bank No.',
        branch: 'Branch',
        glacctNo: 'GL Account No.',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        curr: 'Currency',
        bankAcctBal: 'Balance'
      },
      filters: {
        bankNo: null,
        bankAbbrev: null,
        bankAcctName: null,
        fullBankNo: null,
        branch: null,
        glacctNo: null,
        fund: null,
        acctNoSfx: null,
        curr: null,
        bankAcctBal: null
      },
      sideFunction: [
        {
          text: 'Abbreviated Bank Name',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'bankAbbrev' }
        }
      ],
      totalItems: 0,
      showMore: false,
      selectedBankNo: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.menu.bankList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            const { data } = result.data
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              data.map((bank) => {
                const convertList = {
                  bankNo: bank.bankNo,
                  bankAbbrev: bank.bankAbbrev,
                  bankAcctName: bank.bankAcctName,
                  fullBankNo: bank.fullBankNo,
                  branch: bank.branch,
                  glacctNo: bank.glacctNo,
                  fund: bank.fund,
                  acctNoSfx: bank.acctNoSfx,
                  curr: bank.bankAcctCurr,
                  bankAcctBal: bank.bankAcctBal
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doFilters() {
      this.$validator.validateAll('filters').then((result) => {
        if (result) {
          this.filters.bankAcctBal = removeFormatNumber(this.filters.bankAcctBal)
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.bankNo = null
      this.filters.bankAbbrev = null
      this.filters.bankAcctName = null
      this.filters.fullBankNo = null
      this.filters.branch = null
      this.filters.glacctNo = null
      this.filters.fund = null
      this.filters.acctNoSfx = null
      this.filters.curr = null
      this.filters.bankAcctBal = null
      this.fetchData(false)
    },
    async doDelete(bankNo) {
      this.resetMessages()
      if (bankNo) {
        const apiURI = this.menu.checkDeleteBank
        const apiURI2 = this.menu.deleteBank
        if (apiURI && apiURI2) {
          try {
            await this.$http.get(expandURI(apiURI, { bankNo }))
            this.selectedBankNo = bankNo
            const prompt = await this.$refs.confirmDelete.doPopUp()
            if (prompt) {
              const result = await this.$http.delete(expandURI(apiURI2, { bankNo }))
              const { data } = result
              this.notify(data)
              this.fetchData(false)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.bankParam.menu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  filters: {
    formatDisplayNumber(value) {
      return formatDisplayNumber(value)
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
